import React from 'react';
import PropTypes from 'prop-types';
import iso3166 from 'iso-3166-2';
import { wrapperStyles } from './styles';

const ViewAddress = ({ address }) => {
  let stateOrProvince = '';
  let country = '';

  if (address.country && address.country !== '') {
    country = iso3166.data[address.country]?.name;
    if (address.stateOrProvince && address.stateOrProvince !== '') {
      stateOrProvince =
        iso3166.data[address.country]?.sub[
          `${address.country}-${address.stateOrProvince}`
        ]?.name;
    }
  }

  return (
    <div css={wrapperStyles}>
      <div>{address.addressLine1}</div>
      <div>
        {address.city}
        {address.city && stateOrProvince && ', '}
        {stateOrProvince}
      </div>
      <div>
        {address.postalCode}
        {address.postalCode && country && ', '}
        {country}
      </div>
      <div>{address.phone}</div>
    </div>
  );
};

ViewAddress.propTypes = {
  address: PropTypes.shape({
    addressLine1: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    stateOrProvince: PropTypes.string,
    street: PropTypes.string,
    phone: PropTypes.string,
    postalCode: PropTypes.string,
  }).isRequired,
};

export default ViewAddress;
